import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, Switch } from "antd";
import isEqual from "lodash.isequal";
import dayjs from "dayjs";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import reservationsActions from "../../../redux/reservations/actions";
import ReservationComponent from "../../../components/User/ReservationComponent/ReservationComponent";
import DatePickerComponent from "./DatePickerComponent";
import { useProjectState } from "../../../context/stateContext";
import "./index.css";

const { getRegions, getReservationTable } = restaurantSchemaActions;
const { getReservationsPerRegion } = reservationsActions;

const Reservations = () => {
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState();
  const [date, setDate] = useState(dayjs());
  const [items, setItems] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const { regions } = useSelector((state) => state.restaurantSchemaReducer);

  const {
    showSeatedTimeForReservationTable,
    setShowSeatedTimeForReservationTable,
  } = useProjectState();

  useEffect(() => {
    // Initial fetch on component mount
    dispatch(getRegions());

    // Set up the interval to fetch every minute (60,000 milliseconds)
    const intervalId = setInterval(() => {
      dispatch(getRegions());
    }, 60000); // 60000 ms = 1 minute

    // Clean up the interval on component unmount
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (!isEqual(items, regions) && regions.length > 0) {
      setItems(regions);

      // Ако текущият activeKey не съществува в новите региони, избери първия
      const exists = regions.some((region) => region.key === activeKey);
      const newActiveKey = exists ? activeKey : regions[0].key;
      setActiveKey(newActiveKey);

      dispatch(getReservationTable(newActiveKey));
      dispatch(
        getReservationsPerRegion({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: newActiveKey,
          date: date.format("YYYY-MM-DD"),
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regions]);

  useEffect(() => {
    // Make new request to get RESERVATIONS only when we change the date
    if (regions[0]?.key) {
      dispatch(
        getReservationsPerRegion({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: regions[0]?.key,
          date: date.format("YYYY-MM-DD"),
        })
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onChange = (newActiveKey) => {
    setActiveKey(newActiveKey);
    // Get all Reservation Tables
    dispatch(getReservationTable(newActiveKey));
    dispatch(
      getReservationsPerRegion({
        organizationId: parseInt(localStorage.getItem("organizationId")),
        regionId: newActiveKey,
        date: date.format("YYYY-MM-DD"),
      })
    );
  };

  // Replace the old children with new one
  items.forEach((item) => {
    item.children = (
      <ReservationComponent
        backgroundImage={item.backgroundImage}
        regionId={activeKey}
        date={date}
      />
    );
  });

  return (
    <>
      {screenWidth < 768 && (
        <div className="reservation-date-picker-container">
          <DatePickerComponent date={date} setDate={setDate} />
        </div>
      )}
      <Tabs
        tabBarExtraContent={
          screenWidth >= 768 && (
            <div className="reservation-switch-table-details">
              <Switch
                className="reservation-switch-custom"
                checkedChildren={<span>Заетост на масите</span>}
                unCheckedChildren={<span>Имена на масите</span>}
                checked={showSeatedTimeForReservationTable}
                onChange={(value) =>
                  setShowSeatedTimeForReservationTable(value)
                }
              />
              <DatePickerComponent date={date} setDate={setDate} />
            </div>
          )
        }
        onChange={onChange}
        type="card"
        activeKey={activeKey}
        items={items}
      />
    </>
  );
};
export default Reservations;
